module.exports = __webpack_public_path__ + "img/Benin.7b03c00e.svg";